import React from "react";
// import PropTypes from "prop-types";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
// import Typography from "@material-ui/core/Typography";
// import Tooltip from "@material-ui/core/Tooltip";
import { createTheme } from "@material-ui/core/styles";
import { Col, Row } from "react-bootstrap";
// import { ThemeProvider } from "@material-ui/styles";
// import { TextField } from "@material-ui/core";

const muiTheme = createTheme({
  overrides: {
    MuiSlider: {
      track: {
        color: "#FFD5CE",
      },
      rail: {
        color: "black",
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const AirbnbSlider = withStyles({
  root: {
    color: "#FFD5CE",
    height: 3,
    padding: "13px 0",
  },
  thumb: {
    height: 27,
    width: 27,
    backgroundColor: "#fff",
    // border: "1px solid red",
    marginTop: -12,
    marginLeft: -13,
    boxShadow: "#ebebeb 0 2px 2px",
    "&:focus, &:hover, &$active": {
      boxShadow: "#ccc 0 2px 3px 1px",
    },
    "& .bar": {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: "secondary",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  active: {},
  track: {
    height: 3,
    background: "#FFD5CE 0% 0% no-repeat padding-box",
  },
  rail: {
    color: "#d8d8d8",
    opacity: 1,
    height: 3,
    background: "black",
    background: "#FFD5CE 0% 0% no-repeat padding-box",
  },

  valueLabel: {
    left: "calc(-50% + 7px)",
    top: 40,
    "& *": {
      fontSize: "14px",
      fontWeight: "bold",
      background: "transparent",
      color: "#EE3A23",
    },
  },
})(Slider);

function AirbnbThumbComponent(props) {
  return <span {...props}></span>;
}

export default function RatingsFilter() {
  const classes = useStyles();

  return (
    // <ThemeProvider theme={muiTheme} className="price-filter-main">
    //   <div className={classes.root}>
    //     <Typography gutterBottom>Price</Typography>
    //     <AirbnbSlider
    //       ThumbComponent={AirbnbThumbComponent}
    //       valueLabelDisplay="on"
    //       // marks={10}
    //       getAriaLabel={(index) =>
    //         index === 0 ? "Minimum price" : "Maximum price"
    //       }
    //       defaultValue={[20, 40]}
    //     />
    //   </div>
    //   <div className="d-flex justify-content-between mr-4">
    //     <div>0</div>
    //     <div>Any</div>
    //   </div>

    // </ThemeProvider>
    <div>
      <div className="f14-500">Ratings & Reviews</div>

      <div className="f11-400">
        Lorem ipsum dolor sit amet, consectetur adipiscing
      </div>
      <Row className="mt-3">
        <Col xl={2}></Col>
        <Col xl={8}>
          <div className="w-100 mb-4 spice">
            <Slider
              min={0}
              max={4}
              name="spice_level.level"
              //defaultValue={0}
              // value={formik.values.spice_level.level}
              step={1}
              // onChange={handleSpiceLevelChange}
            />
          </div>
        </Col>

        <Col xl={2}></Col>
        <Col xl={2}></Col>
        <Col xl={9}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="f10-400">0</div>
            {/* <div className="f10-400">Mild</div>
            <div className="f10-400">Medium</div>
            <div className="f10-400">Hot</div> */}
            <div className="f10-400">5 Stars</div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
